// src/components/admin/settings/ContactPageSettings.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import './SettingsPages.css';

const ContactPageSettings = () => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await fetch('https://demo-site.creativepulse.pk/demo-api/public/get-settings.php');
      const data = await response.json();
      if (data.success && data.settings) {
        setSettings(data.settings);
      }
    } catch (error) {
      console.error('Error loading settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setSettings({ ...settings, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const response = await fetch('https://demo-site.creativepulse.pk/demo-api/admin/update-settings-simple.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(settings)
      });
      const data = await response.json();
      if (data.success) {
        toast.success('Contact page saved!');
      } else {
        toast.error('Failed to save');
      }
    } catch (error) {
      toast.error('Connection error');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="loader">Loading contact page...</div>;

  return (
    <div className="settings-page">
      <h2>Contact Page Settings</h2>
      
      <form onSubmit={handleSubmit} className="settings-form">
        <div className="form-group">
          <label>Hero Title</label>
          <input type="text" name="contact_hero_title" value={settings.contact_hero_title || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Hero Subtitle</label>
          <input type="text" name="contact_hero_subtitle" value={settings.contact_hero_subtitle || ''} onChange={handleChange} />
        </div>
        
        <hr className="section-divider" />
        
        <h3>Email Section</h3>
        <div className="form-group">
          <label>Section Title</label>
          <input type="text" name="contact_email_title" value={settings.contact_email_title || ''} onChange={handleChange} />
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Email Address 1</label>
            <input type="email" name="contact_email_1" value={settings.contact_email_1 || ''} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Email Address 2</label>
            <input type="email" name="contact_email_2" value={settings.contact_email_2 || ''} onChange={handleChange} />
          </div>
        </div>
        
        <hr className="sub-divider" />
        
        <h3>Phone Section</h3>
        <div className="form-group">
          <label>Section Title</label>
          <input type="text" name="contact_phone_title" value={settings.contact_phone_title || ''} onChange={handleChange} />
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Phone Number 1</label>
            <input type="text" name="contact_phone_1" value={settings.contact_phone_1 || ''} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Phone Number 2</label>
            <input type="text" name="contact_phone_2" value={settings.contact_phone_2 || ''} onChange={handleChange} />
          </div>
        </div>
        
        <hr className="sub-divider" />
        
        <h3>Address Section</h3>
        <div className="form-group">
          <label>Section Title</label>
          <input type="text" name="contact_address_title" value={settings.contact_address_title || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Address Line 1</label>
          <input type="text" name="contact_address_1" value={settings.contact_address_1 || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Address Line 2</label>
          <input type="text" name="contact_address_2" value={settings.contact_address_2 || ''} onChange={handleChange} />
        </div>
        
        <hr className="sub-divider" />
        
        <h3>Business Hours Section</h3>
        <div className="form-group">
          <label>Section Title</label>
          <input type="text" name="contact_hours_title" value={settings.contact_hours_title || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Hours Line 1</label>
          <input type="text" name="contact_hours_1" value={settings.contact_hours_1 || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Hours Line 2</label>
          <input type="text" name="contact_hours_2" value={settings.contact_hours_2 || ''} onChange={handleChange} />
        </div>
        
        <hr className="section-divider" />
        
        <h3>Contact Form Section</h3>
        <div className="form-group">
          <label>Form Title</label>
          <input type="text" name="contact_form_title" value={settings.contact_form_title || ''} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Success Message</label>
          <input type="text" name="contact_form_success_message" value={settings.contact_form_success_message || ''} onChange={handleChange} />
        </div>
        
        <hr className="section-divider" />
        
        <h3>Google Map</h3>
        <div className="form-group">
          <label>Map Embed URL</label>
          <textarea name="contact_map_embed_url" value={settings.contact_map_embed_url || ''} onChange={handleChange} rows="3" />
        </div>
        
        <button type="submit" disabled={saving} className="save-btn">{saving ? 'Saving...' : 'Save Contact Page'}</button>
      </form>
    </div>
  );
};

export default ContactPageSettings;